import React from "react";

/**
 * @component TaskListAddIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <TaskListAddIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const TaskListAddIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="TaskListAddIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M20 14v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2zm-8 4a1 1 0 010 2H5a1 1 0 010-2h7zm0-4a1 1 0 010 2H5a1 1 0 010-2h7zm7-4a1 1 0 010 2H5a1 1 0 010-2h14zm0-6a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h14z"
        fillRule="evenodd"
      />
    </svg>
  )
);
TaskListAddIcon.displayName = "TaskListAddIcon";
export default TaskListAddIcon;
